import { render } from "./AccountSetting.vue?vue&type=template&id=066ec150&scoped=true"
import script from "./AccountSetting.vue?vue&type=script&lang=js"
export * from "./AccountSetting.vue?vue&type=script&lang=js"

import "./AccountSetting.vue?vue&type=style&index=0&id=066ec150&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066ec150"]])

export default __exports__